import { KodemScoreIcon } from "@/icons"

import styles from "./KodemScoreCell.module.scss"

export const TitleKodemScore = ({ score }: { score: number }) => (
  <div className={styles.titleScore}>
    <KodemScoreIcon score={score} />
    <div className={styles.titleWrapper}>
      <b className={styles.titleBold}>{score}</b>
      <span className={styles.titleScoreSecondary}> \1000</span>
    </div>
  </div>
)
